import React from "react";
//Bootstrap and jQuery libraries
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import { Link } from "react-router-dom";
import ReactDatatable from "@ashvin27/react-datatable";
import Modal from 'react-bootstrap/Modal';
import { read, utils } from 'xlsx';
import { strings } from "./../../localization";
import { Language, API_URL, LIMIT } from "./../../config";
import { Container, Row, Col, Card, Button, CardBody } from "shards-react";
import SearchFilter from "./../search_filter";

import PageTitle from "../../components/common/PageTitle";
import swal from "sweetalert2";
import moment from "moment";
window.Swal = swal;
const filters = [
  {
    name: "Code"
  },
  {
    name: "Name"
  },
  {
    name: "Barcode Number"
  },
  {
    name: "Price"
  },
  {
    name: "Stock"
  },
];

class Subitems extends React.Component {
  state = {
    alert: null,
    records: [],
    total: 0,
    skip: 0,
    limit: LIMIT,
    currentPage: 1,
    prev: true,
    loading: true,
    next: false,
    value: "",
    suggestions: [],
    paramValue: "",
    selectedExcelFile: "",
    showSuccessMsg: false,
    successMsg: "",
    showErrorMsg: false,
    errorMsg: "",
    isLoading: false,
    isDownloadCsvLoading: false,
    isUploadCsvLoading: false,
    hasRestaurantPermission: false,
    kitchens: [],
    bars: [],
    kitchenOrBarList: [],
    itemTypes: [],
    selectedItemType: ''
  };
  constructor(props) {
    super(props);
    strings.setLanguage(Language);

    this.columns = [
      {
        key: "code",
        text: "SKU"
      },
      {
        key: "name",
        text: "Nombre"
      },
      {
        key: "barcodeNumber",
        text: "Código de barra"
      },
      {
        key: "stock",
        text: "Stock"
      },
      {
        key: "price",
        text: "Precio total con IVA incluido"
      },
      {
        key: "expirationDate",
        text: strings.expiration_date
      },
      {
        key: "action",
        text: "Acción",
        // width: 100,
        sortable: false,
        cell: record => {
          return (
            //   /create-customer
            <div className="mt-2">
              <Link
                to={{
                  pathname: "/manage-subitem/" + record.id,
                  state: {
                    type: "edit",
                    name: record.name,
                    code: record.code,
                    price: record.price,
                    stock: record.stock
                  }
                }}
              >
                <Button theme="success" className="mb-2 mr-1">
                  {strings.edit}
                </Button>
              </Link>
              <Button
                theme="danger"
                className="mb-2 mr-1"
                onClick={() => this.deleteItem(record.id)}
              >
                {strings.delete}
              </Button>
            </div>
          );
        }
      }
    ];
    this.config = {
      // page_size: 10,
      show_length_menu: false,
      show_info: false,
      show_pagination: false,
      button: {
        excel: false,
        print: false,
        extra: false
      }
    };
  }

  deleteItem(id) {
    let statuscode = 0
    swal
      .fire({
        title: strings.are_you_sure,
        text: strings.delete_item,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: strings.yes_cancel,
        confirmButtonColor: "#2E209D",
        cancelButtonColor: "#D61E11",
        confirmButtonText: strings.yes_delete,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return fetch(`${API_URL}sub-item/${id}`, {
            method: "delete",
            credentials: "include",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          })
            .then(res => {
              statuscode = res.status
              return res.json();
            }).then(res => {
              if (statuscode == 200) {
                this.getData();

                swal.fire(
                  strings.deleted,
                  strings.success_item_deleted,
                  "success"
                );
              } else {
                const message = res.message || "Something went wrong"
                swal.showValidationMessage(`Request failed: ${message}`);
              }
            })
            .catch(err => {
              swal.showValidationMessage(`Request failed: ${err}`);
            });
        }
      })
      .then(result => { });
  }

  arrayIndexMove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  componentDidMount() {
    let restaurantPermission = false;
    let organizationData = JSON.parse(localStorage.getItem("organisation_info"));
    if (organizationData !== undefined && organizationData !== null &&
      organizationData['data']['restaurantModule'] !== undefined && organizationData['data']['restaurantModule'] !== null
    ) {
      restaurantPermission = organizationData['data']['restaurantModule'];
    }
    if (restaurantPermission) {
      let itemType = {
        key: "restaurantItemType",
        text: strings.item_type,
        cell: record => {
          const value = record.restaurantItemType ? record.restaurantItemType.label : ""
          return (
            <p>{value}</p>
          )
        }
      };
      this.columns.push(itemType);
      this.arrayIndexMove(this.columns, this.columns.length - 1, 6)
      let preparationArea = {
        key: "preparationArea",
        text: strings.preparation_area,
        cell: record => {
          const value = record.preparationArea ? record.preparationArea.label : ""
          return (
            <p>{value}</p>
          )
        }
      };
      this.columns.push(preparationArea);
      this.arrayIndexMove(this.columns, this.columns.length - 1, 7);
    }
    this.setState({
      hasRestaurantPermission: restaurantPermission
    })
    this.getData();
  }

  getData = (skip = 0, params = "") => {
    this.setState({
      loading: true
    });

    fetch(`${API_URL}sub-item?limit=${this.state.limit}&skip=${skip}${params}`, {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(res => {
        if (res.result.length > 0) {
          let array = [];

          res.result.map(item => {
            let obj = item.data;
            if (obj['expirationDate'] !== undefined && obj['expirationDate'] !== null && obj['expirationDate'] !== "") {
              obj['expirationDate'] = moment(obj['expirationDate']).format('YYYY-MM-DD');
            }
            console.log("🚀 ~ file: index.js:208 ~ Customers ~ obj:", obj)
            obj = Object.assign({ id: item._id }, obj);
            array.push(obj);
          });

          if (res.result.length !== this.state.limit) {
            this.setState({
              next: true
            });
          }

          this.setState({
            total: res.result.length + 1,
            records: array,
            loading: false
          });
        } else {
          this.setState({
            next: true,
            loading: false,
            records: []
          });
        }
      })
      .catch(err => {
        this.setState({
          loading: false
        });
      });
  };

  getParamValue = (value) => {
    console.log("🚀 ~ file: index.js ~ line 222 ~ Customers ~ value", value)
    this.setState({ paramValue: value });
  }

  pageIncrement() {
    if (!this.state.next) {
      let skip = this.state.currentPage * this.state.limit;
      this.getData(skip);
      this.setState({
        currentPage: this.state.currentPage + 1,
        prev: false,
        skip: skip
      });
    }
  }

  pageDecrement() {
    if (this.state.skip > 0) {
      let skip = this.state.skip - this.state.limit;
      if (skip >= 0) {
        this.getData(skip);
        if (skip === 0) {
          this.setState({
            prev: true
          });
        }
        this.setState({
          currentPage: this.state.currentPage - 1,
          next: false,
          skip: skip
        });
      } else {
        this.setState({
          prev: true,
          next: false
        });
      }
    } else {
      this.setState({
        next: false
      });
    }
  }

  showInfoMessage(type, msg) {
    type = type.toLocaleLowerCase();
    console.log('message type: ' + type);
    if (type === 'success') {
      this.setState({
        showSuccessMsg: true,
        successMsg: msg
      });
      setTimeout(() => {
        this.setState({
          showSuccessMsg: false,
          successMsg: ''
        });
      }, [3000]);
    } else {
      this.setState({
        showErrorMsg: true,
        errorMsg: msg
      });
      setTimeout(() => {
        this.setState({
          showErrorMsg: false,
          errorMsg: ''
        });
      }, [3000]);
    }
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">

        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={strings.subitems}
            className="text-sm-left"
          />
        </Row>
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-3 pb-3">
                <SearchFilter getData={this.getData} getParamValue={this.getParamValue} filters={filters} />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-3 pb-3">
                <div className="d-flex justify-content-between align-items-center'">
                  <div className="d-flex align-items-center">
                    <Link to="manage-subitem">
                      <Button theme="primary" className="float-right">
                        <i class="material-icons">add</i> {strings.create_subitem}
                      </Button>
                    </Link>
                  </div>
                </div>
                <div className="MainDiv">
                  <div className="table-responsive">
                    <ReactDatatable
                      config={this.config}
                      records={this.state.records}
                      columns={this.columns}
                      loading={this.state.loading}
                    />
                    <nav className="d-flex justify-content-center align-items-center">
                      <ul className="pagination">
                        <li className="page-item">
                          <a
                            className="page-link"
                            href="javascript:;"
                            onClick={() => this.pageDecrement()}
                            style={
                              this.state.prev
                                ? { cursor: "not-allowed", color: "gray" }
                                : null
                            }
                          >
                            Anterior
                          </a>
                        </li>
                        <li className="page-item">
                          <a
                            className="page-link"
                            href="javascript:;"
                            onClick={() => this.pageIncrement()}
                            style={
                              this.state.next
                                ? { cursor: "not-allowed", color: "gray" }
                                : null
                            }
                          >
                            Próxima
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}
export default Subitems;
